import React, {useEffect, useMemo, useState, useRef} from 'react';
import { latinAlphabet} from "../../../utils/variables";
import Input from "../../master/Input";
import CarSelect from "../../master/CarSelect";
import SearchablePicker from "../../master/SearchablePicker";
import Plate from "../Plate";
import PositionPicker from "../PositionPicker";
import {toast, validate, pexios, getDirection} from "../../../utils/functions";
import ExpertImage from "../ExpertImage";
import { useTranslation } from 'react-i18next';
import { toast as toast2 } from 'react-toastify';

export default function CarData({ data, changeData, uploadImage, changeStep, userType = 'culprit', lossesIndex = 0 }) {

    const form = useRef(null);
    const imageForm = useRef(null);
    const { t, i18n } = useTranslation();
    const [colors, setColors] = useState([]);

    const title = useMemo(() => userType === 'culprit' ? t('Culprit') : `${t('Losses')} ${t(latinAlphabet[lossesIndex])}`, [lossesIndex, userType]);
    const imageSuffix = useMemo(() => userType === 'losses' ? (lossesIndex + 1) : '', [lossesIndex, userType]);
    useEffect(() => {
        pexios('api/get_color')
            .then(res => {
                setColors(res.data);
            });
    }, []);

    function nextStep() {
        toast2.dismiss();
        // const numberRegex = /^\d+$/;
        // if(data.car_value && !numberRegex.test(data.car_value)) {
        //     toast("ارزش روز وسیله را به درستی وارد نمایید",'error');
        //     return;
        // }
        // if(data.car_value.length < 4 ) {
        //     if(data.insurance_type === 'body'&& data.body.insurance_value < 4){
        //         toast("ارزش روز وسیله و ارزش مورد بیمه را به درستی وارد نمایید",'error');
        //         return;
        //     }
        //     if(data.insurance_type !== 'body'&& data.third.insurance_value < 4){
        //         toast("ارزش روز وسیله و تعهد مالی را به درستی وارد نمایید",'error');
        //         return;
        //     }
        //     toast("ارزش روز وسیله را به درستی وارد نمایید",'error');
        //     return;
        // }  

        const error = validate(form) + (validate(form) && validate(imageForm) && '،') + validate(imageForm);
        if (error) {
            // toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            toast(t('Complete required fields',{err:error}), 'error');
            return;
        }
        changeStep(5);
    }
    return (
        <>
            <h4 className='mt20 border-title title-text'>{`${t('Car info')} ${title}`}</h4>
            <div className={`row ${getDirection(i18n.language) ==='rightToLeft'?'text-right':'text-left'} `} ref={form}>
                {
                    data.insurance_type === 'body' &&
                    <>
                        <Input
                            label={t('Owner full name')}
                            value={data.owner_name}
                            required
                            onChange={value => changeData(value, 'owner_name')}
                        />
                        <Input
                            label={t('Owner national id')}
                            value={data.owner_national_id}
                            maxLength={10}
                            required
                            onChange={value => changeData(value, 'owner_national_id')}
                        />
                    </>
                }
                <CarSelect
                    data={{
                        carType: data.car_type_id,
                        carBrand: data.car_brand_id,
                        carModel: data.car_model_id,
                    }}
                    required
                    onChange={(value, type) => changeData(value, type)}
                    PlateType={data?.plate_type}
                />
                <SearchablePicker
                    label={t('Car color')}
                    value={data.car_color_id}
                    data={colors}
                    titleKey='name'
                    valueKey='id'
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    required
                    onSelect={color => changeData(color, 'car_color_id')}
                />
                <Input
                    label={t('Chassis number')}
                    value={data.chassis_number}
                    onChange={value => changeData(value, 'chassis_number')}
                    
                />
                <Input
                    label={t('Motor number')}
                    value={data.motor_number}
                    required
                    onChange={value => changeData(value, 'motor_number')}
                />
                <Input
                    label={t('VIN')}
                    value={data.vin_number}
                    required
                    onChange={value => changeData(value, 'vin_number')}
                />
                <Input
                    label={t('Produce year')}
                    value={data.production_year}
                    mode='numeric'
                    required
                    onChange={value => changeData(value, 'production_year')}
                />

                <Input
                    label={t('Current vehicle price rial')}
                    value={data.car_value}
                    mode='numeric'
                    type='price'
                    required={data.insurance_type === 'body' || userType === 'losses'}
                    onChange={value => changeData(value, 'car_value')}
                />
                {userType === 'culprit' &&
                    <Input
                        label={data.insurance_type === 'body' ? 'ارزش مورد بیمه' : 'تعهد مالی'}
                        value={data.insurance_type === 'body'? data.body?.insurance_value : data.third?.insurance_value}
                        mode='numeric'
                        type='price'
                        required
                        onChange={value => changeData(value, 'insurance_value',`${data.insurance_type === 'body'? 'body' : 'third'}`)}
                    />
                }
                <Plate
                    type={data.plate_type}
                    plate={{
                        plate_iran: data.plate_iran,
                        plate_left: data.plate_left,
                        plate_center: data.plate_center,
                        plate_right: data.plate_right,
                    }}
                    required
                    change={(value, name) => changeData(value, name)}
                />
                <PositionPicker
                    label={t('Damaged positions')}
                    value={data.position}
                    placeholder={t('Damaged positions')}
                    required
                    onSelect={value => changeData(value, 'position')}
                />
            </div>
            <div className='gridParent' ref={imageForm}>
                <ExpertImage
                    title={t('Car Card image')}
                    src={data.attachments.filter(itm => itm.filename.includes(`${userType}_vehicle_card_image${imageSuffix}`))}
                    upload={(img, done) => uploadImage(img, `expert_${userType}_vehicle_card_image${imageSuffix}`, done)}
                    label='vehicle_card_image'
                    // required={!(userType === 'culprit' && data.insurance_type === 'third' && data.has_coroukie === 1)}
                />
                <ExpertImage
                    title={t('Car back card image')}
                    src={data.attachments.filter(itm => itm.filename.includes(`${userType}_vehicle_card_back_image${imageSuffix}`))}
                    upload={(img, done) => uploadImage(img, `expert_${userType}_vehicle_card_back_image${imageSuffix}`, done)}
                    label='vehicle_card_back_image'
                    // required={!(userType === 'culprit' && data.insurance_type === 'third' && data.has_coroukie === 1)}
                />
            </div>
            <div className='d-flex mt20 pr5 pl5'>
                <button
                    onClick={() => changeStep(data.insurance_type === 'body' ? 3 : 2)}
                    className='btn btn-orange btn-block btn-circle-left'
                >
                    {t('Prev step')}
                </button>
                <button
                    onClick={nextStep}
                    className='btn btn-white-purple btn-block btn-circle-right'
                >
                    {t('Next step')}
                </button>
            </div>
        </>
    );
}
